import React, { useContext } from 'react'
import { LoginContext } from '../context/LoginContext'
import { Navigate } from "react-router-dom";

export const PublicRoute = ({
    children,
    user
}) => {

    console.log("public")
    console.log(!user)

    return user
        ? <Navigate to='/' />
        : children


}
